import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import Scrollbar from 'react-scrollbars-custom';
import Util from '../../script/util';
import HTTP from '../../script/service';
import { DDLoading } from '../globalPageStatus';

const FaceTab = [
  { tab: 'maomi', type: 2 },
  { tab: 'daidai', type: 1 },
  { tab: 'default' },
];

class Face extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      emoji: [],
      faceTab: 'default', // 当前展示表情包
      customEmojiData: {}, // 缓存自定义表情列表
      customEmoji: [], // 自定义表情当前展示的列表
    };
  }

  componentDidMount() {
    this.setDefaultEmoji();
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  // 获取表情
  getRoomMagics = (type) => {
    if (type == null || type === '') return;
    this.setState({ loading: true }, () => {
      HTTP._get_room_magics({ magicType: type })
        .then((res) => {
          let faces = [];
          if (res.code === 200) {
            faces = res.data;
          }
          const customEmojiData = {
            ...this.state.customEmojiData,
            [type]: faces,
          };
          this.setState({ customEmoji: faces, customEmojiData });
        })
        .finally(() => this.setState({ loading: false }));
    });
  };

  setDefaultEmoji = () => {
    let emoji = [];
    for (let key in this.props.base.rootConfig.emojiList.emoji) {
      emoji.push({
        id: key,
        value: this.props.base.rootConfig.emojiList.emoji[key],
      });
    }
    const defaultTab = 'maomi';
    this.setState(
      {
        faceTab: defaultTab,
        emoji: emoji,
      },
      () => {
        const find = FaceTab.find((n) => n.tab === defaultTab);
        if (find && find.type) {
          // 获取表情
          this.getRoomMagics(find.type);
        }
      }
    );
  };

  // 切换表情类型
  handleChangeFaceTab = (item) => {
    let tab = item ? item.tab : 'default';
    if (!!item.type) {
      const { customEmojiData } = this.state;
      if (customEmojiData[item.type]) {
        this.setState({ customEmoji: customEmojiData[item.type] });
      } else {
        // 获取表情
        this.getRoomMagics(item.type);
      }
    }
    this.setState({ faceTab: tab });
  };

  render() {
    const { onSelectEmoji } = this.props;
    const { loading, faceTab, emoji, customEmoji } = this.state;
    return (
      <span>
        {this.props.visible ? (
          <div
            className="face-all-plan"
            onClick={(e) => this.props.toggleFace(e, true)}
          >
            <div className="face-plan">
              <Scrollbar className="my-scroll-bar">
                <DDLoading status={loading}>
                  <div className="all-emoji">
                    {faceTab === 'default'
                      ? emoji.map((item) => (
                          <span
                            className="em default"
                            key={item.id}
                            onClick={onSelectEmoji.bind(this, item.id, null)}
                          >
                            <img
                              alt={item.id}
                              title={item.id}
                              src={Util.transImgUrl(
                                `/assets/emoji/${item.value.file}`
                              )}
                            />
                          </span>
                        ))
                      : customEmoji && customEmoji.length
                        ? customEmoji.map((item) => (
                            <span
                              key={item.id}
                              className={`em item-custom ${item.tab}`}
                              onClick={onSelectEmoji.bind(this, item, 3)}
                            >
                              <span className="face-img">
                                <img
                                  alt={item.name}
                                  title={item.name}
                                  src={Util.transImgUrl(item.pic)}
                                />
                              </span>
                              <span className="face-text">{item.name}</span>
                            </span>
                          ))
                        : null}
                  </div>
                </DDLoading>
              </Scrollbar>
            </div>
            <ul className="faces-type-tab">
              {FaceTab.map((item) => (
                <li
                  key={item.tab}
                  className={`face-type ${item.tab}${faceTab === item.tab ? ' active' : ''}`}
                  onClick={() => this.handleChangeFaceTab(item)}
                >
                  <span className="icon" />
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </span>
    );
  }
}

export default withRouter(Face, { withRef: true });
